export type CardFieldPage = "front" | "back";

export type CardFieldKey =
  | "fullName"
  | "jobTitle"
  | "phone"
  | "email"
  | "department"
  | "website"
  | "qr";

export type CardFieldAlign = "left" | "center" | "right";

/**
 * One stamped field on a template page. Coordinates/sizes are in PDF points
 * (1/72in), origin bottom-left of the page — matches CardFieldDto on the
 * backend exactly (field order mirrors the Java record for easy comparison).
 */
export type CardField = {
  page: CardFieldPage;
  key: CardFieldKey;
  x: number;
  y: number;
  width: number;
  height: number;
  fontSize?: number | null;
  align?: CardFieldAlign | null;
};

export type CardTemplate = {
  id: number;
  name: string;
  frontWidthPt: number;
  frontHeightPt: number;
  hasBackPage: boolean;
  backWidthPt: number | null;
  backHeightPt: number | null;
  active: boolean;
  fields: CardField[];
};

export const CARD_FIELD_LABELS: Record<CardFieldKey, string> = {
  fullName: "Full name",
  jobTitle: "Job title",
  phone: "Phone",
  email: "Email",
  department: "Department",
  website: "Website",
  qr: "QR code",
};
